import src from "IMAGE";
export default { src, width: 159, height: 44, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPklEQVR42j3FywmAQBBEwc0/Og+CIohG4IdxB7v38BQED0WVORrjafrdTO/1FrZ/Zb0aw2G6TSxhoiaZH0k83sw9UU0Cx08AAAAASUVORK5CYII="};
